/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PortfolioReportReason } from './';
import {
    PortfolioReportReasonFromJSON,
    PortfolioReportReasonFromJSONTyped,
    PortfolioReportReasonToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioItemReportRequest
 */
export interface PortfolioItemReportRequest {
    /**
     * 
     * @type {Array<PortfolioReportReason>}
     * @memberof PortfolioItemReportRequest
     */
    reasons: Array<PortfolioReportReason>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemReportRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the PortfolioItemReportRequest interface.
 */
export function instanceOfPortfolioItemReportRequest(value: object): value is PortfolioItemReportRequest {
    if (!('reasons' in value) || value['reasons'] === undefined) return false;
    return true;
}

export function PortfolioItemReportRequestFromJSON(json: any): PortfolioItemReportRequest {
    return PortfolioItemReportRequestFromJSONTyped(json, false);
}

export function PortfolioItemReportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioItemReportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reasons': ((json['reasons'] as Array<any>).map(PortfolioReportReasonFromJSON)),
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function PortfolioItemReportRequestToJSON(value?: PortfolioItemReportRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reasons': ((value['reasons'] as Array<any>).map((v) => PortfolioReportReasonToJSON(v))),
        'comment': value['comment'],
    };
}

